import exportToExcel from '@/utils/excelExport';

const sanitizeText = text => {
  let _text = text;

  if (_text) {
    _text = text
      .replace(/\u00A0/g, '')
      .replace('<[^>]*>', '')
      .replace(/&lt;/g, '<')
      .replace(/&gt;/g, '>')
      .replace(/&amp;/g, '&')
      .replace(/&hellip;/g, '...')
      .replace(/&sect;/g, '§')
      .replace(/&bull;/g, '•')
      .replace(/<(?:br|\/div|\/p)>/g, '\n')
      .replace(/<.*?>/g, '')
      .replace(/&ndash;|&mdash;/g, '-')
      .replace(/&rsquo;|&lsquo;/g, "'")
      .replace(/&rdquo;|&ldquo;/g, '"')
      .replace(/&nbsp;/g, ' ');
  }

  return _text;
};
export default async ({ data, sheetTitle = 'APCIA Export', fileName = 'sheet.xlsx' }) => {
  const exportData = data.map(d => {
    const { ChartTitle, ChartState, ChartTopic, Details, RecentChanges, StateNotes } = d;

    return [
      ChartTitle,
      ChartState,
      ChartTopic,
      sanitizeText(Details),
      sanitizeText(RecentChanges),
      sanitizeText(StateNotes),
    ];
  });

  const columns = ['Chart', 'State', 'Topic', 'Details', 'Most Recent Changes', 'State Notes'];

  exportToExcel(columns, exportData, sheetTitle, fileName);
};
